module.exports = __webpack_public_path__ + "static/venus-f30a5dc9e70018949c8dd61ccbfbf2b1.png";